import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { providerApi } from "../../api/client";
import OIMSignature from "../provider/OIMSignature.jpg";
import { FiMail } from "react-icons/fi";

const Certificate = () => {
  const { user } = useAuth();
  const [fetchedProfile, setFetchedProfile] = useState(null);
  const certificateRef = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await providerApi.getMyProfile();
        const p = res?.providerProfile || res?.profile || res || null;
        if (p) setFetchedProfile(p);
      } catch (err) {
        console.error("Failed to fetch profile for certificate", err);
      }
    })();
  }, []);

  const profile = fetchedProfile || user || {};

  // Dates
  const issueDate = new Date(profile?.approvedAt || Date.now());
  const expiryDate = new Date(issueDate);
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);

  // 🖨️ Print Style
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          background: white !important;
        }
        @page {
          size: A4 portrait;
          margin: 10mm;
        }
        body * {
          visibility: hidden;
        }
        .certificate-print, .certificate-print * {
          visibility: visible;
        }
        .certificate-print {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          transform: scale(0.95);
          transform-origin: top center;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const handlePrint = () => {
    window.print();
  };
  

  return (
    <div className="flex flex-col items-center bg-gray-100 py-10 min-h-screen">
      <div
        ref={certificateRef}
        className="certificate-print relative bg-white w-full max-w-3xl border border-[#d1b27b] rounded-lg shadow-2xl p-10 overflow-hidden"
      >
        {/* 🇮🇳 Watermark Background with Tricolor Gradient + Verified Tick */}
        {/* <div className="absolute inset-0 flex flex-col items-center justify-center opacity-15 select-none pointer-events-none">
          
          <div
            className="flex items-center gap-6"
            style={{
              transform: "rotate(-25deg)",
            }}
          >
            <h1
              className="text-[18rem] font-extrabold tracking-widest text-transparent bg-clip-text"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #FF9933, #d6d4d4, #138808)",
                textShadow: "0 0 25px rgba(0,0,0,0.1)",
                fontFamily: "serif",
              }}
            >
              OIM
            </h1>

            <div>
              <svg
                className="w-20 h-20 text-blue-800"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z" />
              </svg>
            </div>
          </div>
        </div> */}

        {/* Golden Border */}
        <div className="absolute inset-0 border-[4px] border-[#cfa44d] rounded-lg pointer-events-none"></div>

        {/* Top logo */}
        <div className="text-center mb-3 relative z-10">
          <img
            src="https://ssbponetwork.com/img/logo2.svg"
            alt="Trust Seal"
            className="h-20 mx-auto mb-2"
          />
        </div>

        {/* Title */}
        <h2 className="text-center text-lg font-semibold text-gray-700 mb-1 relative z-10">
          CERTIFICATE OF TRUST
        </h2>

        {/* Company Name */}
        <h1 className="text-center text-2xl font-bold text-[#d68500] relative z-10">
          {profile?.companyName || "_______"}
        </h1>

        {/* Description */}
        <p className="text-center text-gray-700 text-base max-w-xl mx-auto leading-relaxed mb-6 relative z-10">
          has been certified as a trusted member of{" "}
          <span className="font-semibold text-xl text-green-700">OIM</span>
        </p>

        <hr className="border-t-2 border-gray-300 mb-8 relative z-10" />

        {/* Details section */}
        <div className="text-base text-gray-800 space-y-4 mb-6 relative z-10">
          <p>
            <span className="font-semibold">Company Name:</span>{" "}
            {profile?.companyName || "_________"}
          </p>
          <p>
            <span className="font-semibold">GSTIN:</span>{" "}
            {profile?.gstNumber || "________"}
          </p>
          <p>
            <span className="font-semibold">PAN No:</span>{" "}
            {profile?.panNumber || "________"}
          </p>
          <p>
            <span className="font-semibold">Business Address:</span>{" "}
            {profile?.address || "_________________"}
          </p>
          <p>
            <span className="font-semibold">Mobile Number:</span>{" "}
            {profile?.phoneNumber || "__________"}
          </p>
        </div>

        {/* Dates */}
        <div className="flex justify-center gap-12 text-base text-gray-700 mt-6 relative z-10">
          <p>
            <span className="font-semibold">Issue Date:</span>{" "}
            {issueDate.toLocaleDateString("en-GB")}
          </p>
          <p>
            <span className="font-semibold">Expiry Date:</span>{" "}
            {expiryDate.toLocaleDateString("en-GB")}
          </p>
        </div>

        {/* Signature Section */}
        <div className="text-start mt-8 relative z-10">
          <img src={OIMSignature} alt="signatureImage" className="h-16 ml-2" />
          <p className="border-t-2 border-gray-600 w-40 mt-1"></p>
          <p className="text-sm text-gray-700 mt-1">Authorized Signature</p>
        </div>

        {/* Bottom info */}
        <div className="mt-2 text-center relative z-10">
          <img
            src="https://ssbponetwork.com/img/logo2.svg"
            alt="IndiaMART Logo"
            className="h-14 mx-auto mb-2"
          />
          <p className="text-sm text-gray-700 max-w-sm mx-auto">
            <b>Sabka Sabkuch Business Private Limited</b> <br />
            <b>Online Indian Market (OIM)</b> <br />
            510, 5th Floor, Vishwa Sadan Tower, District Centre, Janak Puri, New
            Delhi – 110058
          </p>
          <p className="text-sm text-gray-700 mt-1">
            <span className="flex items-center justify-center gap-1">
              <FiMail className="font-bold " />
              contact.onlineindianmarket@gmail.com
            </span>
          </p>
          <p className="italic text-gray-600 mt-2 text-sm">
            🇮🇳 Made in India with Pride
          </p>
        </div>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="mt-6 px-6 py-2 bg-[#138808] text-white font-semibold rounded-lg hover:bg-[#0a5e05] transition"
      >
        🖨️ Print Certificate
      </button>
    </div>
  );
};

export default Certificate;
